import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { VariableType } from 'shared/src'
import type { GlobalVariable } from 'shared/src'
import fetchApi from '@/utils/fetchApi'

export interface UpdateVariableParams {
  id: string
  name: string
  type: VariableType
  fallbackValue: string
  description?: string
}

export function useUpdateVariableMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: UpdateVariableParams) => {
      return fetchApi<GlobalVariable>(
        {
          endpoint: `/api/variables/${id}`,
          method: 'PUT',
          body,
        },
        { suppressAlert: true },
      )
    },
    onSuccess: (_, { id }) => {
      void queryClient.invalidateQueries({ queryKey: ['variables', 'list'] })
      void queryClient.invalidateQueries({ queryKey: ['variables', 'all'] })
      void queryClient.invalidateQueries({ queryKey: ['variables', id] })
      void queryClient.invalidateQueries({ queryKey: ['configurations', 'list'] })
    },
  })
}
